import { render } from "./SwitchButton.vue?vue&type=template&id=5bd2114e&ts=true"
import script from "./SwitchButton.vue?vue&type=script&lang=ts"
export * from "./SwitchButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__